'use client';

import { Box, Container, Typography, useTheme } from '@mui/material';
import { useIsUnderBreakpoint } from '@qb/frontend/hooks/mediaQueries';
import { BlogPageProps } from '../../../pages/blog';
import { BackgroundGraphics } from './components/BackgroundGraphics';
import { HubspotBlogForm } from './components/HubspotBlogForm';
import { PostsListDesktop } from './components/PostsListDesktop';
import { PostsListMobile } from './components/PostsListMobile';
export const Blog = ({
  posts
}: BlogPageProps) => {
  const theme = useTheme();
  const isUnderSm = useIsUnderBreakpoint('sm');
  const isUnderLg = useIsUnderBreakpoint('lg');
  return <Box sx={{
    backgroundColor: 'common.white',
    minHeight: '90vh',
    position: 'relative',
    overflow: 'hidden',
    pb: 4
  }} data-sentry-element="Box" data-sentry-component="Blog" data-sentry-source-file="Blog.tsx">
      {isUnderLg ? null : <BackgroundGraphics />}
      <Container component="main" maxWidth="lg" sx={{
      position: 'relative',
      zIndex: 1
    }} data-sentry-element="Container" data-sentry-source-file="Blog.tsx">
        <Box sx={{
        textAlign: 'center',
        pt: {
          xs: 4,
          md: 8
        },
        pb: {
          xs: 2,
          md: 7
        }
      }} data-sentry-element="Box" data-sentry-source-file="Blog.tsx">
          <Typography component="h1" sx={{
          typography: {
            xs: 'h5',
            md: 'h4'
          }
        }} data-sentry-element="Typography" data-sentry-source-file="Blog.tsx">
            Quotebeam blog
          </Typography>
          <Typography sx={{
          typography: {
            xs: 'h3',
            md: 'h1'
          }
        }} data-sentry-element="Typography" data-sentry-source-file="Blog.tsx">
            The Second Shift
          </Typography>
          <Typography sx={{
          typography: {
            xs: {
              ...theme.typography.h5,
              color: theme.palette.text.secondary
            },
            md: {
              ...theme.typography.h4,
              color: theme.palette.text.secondary
            }
          },
          maxWidth: 'sm',
          mx: 'auto'
        }} data-sentry-element="Typography" data-sentry-source-file="Blog.tsx">
            {`Quotebeam's insights, latest industry trends, and whatever else comes to our minds`}
          </Typography>
        </Box>
        <HubspotBlogForm data-sentry-element="HubspotBlogForm" data-sentry-source-file="Blog.tsx" />
        {isUnderSm ? <PostsListMobile posts={posts} /> : <PostsListDesktop posts={posts} />}
      </Container>
    </Box>;
};